import { render, staticRenderFns } from "./signUp.vue?vue&type=template&id=37cac896&scoped=true&"
import script from "./signUp.vue?vue&type=script&lang=ts&"
export * from "./signUp.vue?vue&type=script&lang=ts&"
import style0 from "./signUp.vue?vue&type=style&index=0&id=37cac896&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cac896",
  null
  
)

export default component.exports